import script from "./NewConvertLifecycle.vue?vue&type=script&setup=true&lang=js"
export * from "./NewConvertLifecycle.vue?vue&type=script&setup=true&lang=js"

import "./NewConvertLifecycle.vue?vue&type=style&index=0&id=00dd5084&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00dd5084"]])

export default __exports__